














































































import Vue, { PropType } from 'vue';
import InfoDialog from '@/components/info/InfoDialog.vue';
import { groupRoleColors } from '../utils/unrulrColors';
import { BasePeerGroup, MemberRole } from '@/models';

export default Vue.extend({
  components: {
    InfoDialog
  },

  props: {
    size: {
      type: String,
      default: 'x-small'
    },
    showGeneralInfo: {
      type: Boolean,
      default: true
    },
    peerGroup: {
      type: Object as PropType<BasePeerGroup>,
      required: false
    }
  },

  data() {
    return {
      colorClasses: groupRoleColors.all
    };
  },

  computed: {
    roleNameStudent(): string {
      return this.peerGroup?.roleNameStudent ?? MemberRole.STUDENT;
    },
    roleNameTeacher(): string {
      return this.peerGroup?.roleNameTeacher ?? MemberRole.TEACHER;
    },
    roleNameObserver(): string {
      return MemberRole.OBSERVER;
    }
  }
});
